import React, { useEffect, useRef, useState } from 'react'
import { ManualCertFormData } from './data/ManualCertForm.Data'
import FormCreator from '../../components/forms/FormCreator'
import Buttons from '../../components/ui/button/Buttons'
import CenterModel from '../../components/ui/centerModel/CenterModel'
import * as XLSX from "xlsx";
import * as Yup from 'yup';
import CertExcelFileDataTable from './components/CertExcelFileDataTable'
import SwalAlert from '../../services/swalService/SwalService'
import { useUploadPDFMutation } from '../../app/services/common/commonServiceApi'
import { useGenerateManualEventAttendanceCertMutation } from '../../app/services/ManualEventCert/ManualEventCertServiceApi'
import { getAuditContext } from '../../lib/authenticationLibrary'

const GenerateManualEventAttendenceCertificateForm = () => {
    const fileRef = useRef(null);
    const certGenerateFormRef = useRef(null);
    const { error, success } = SwalAlert();
    const audit = getAuditContext();
    const [errors, setErrors] = useState([]);
    const [jsonData, setJsonData] = useState([]);
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [file, setFile] = useState(null);
    const [isExcelUploaded, setIsExcelUploaded] = useState(false);
    const [manualCertGenerateForm, setManualCertGenerateForm] = useState(ManualCertFormData);

    const [uploadFile, { isLoading }] = useUploadPDFMutation();
    const [submitGenerateCert, { isSuccess: generateCertIsSuccess, isLoading: generateCertLoading, data: generateCertResponse }] = useGenerateManualEventAttendanceCertMutation();

    useEffect(() => {
        if (!generateCertLoading && generateCertIsSuccess && generateCertResponse) {
            if (generateCertResponse?.insertedAttandiList?.length > 0) {
                success("Submitted Successfully.").then(() => openExcelModel());
                ResetFormData();
            }
        }
    }, [generateCertLoading, generateCertIsSuccess, generateCertResponse]);

    const ResetFormData = () => {
        let form = { ...ManualCertFormData }
        form.initialState = {
            eventName: null,
            eventDate: null,
            startTime: null,
            endTime: null,
            certificateFor: null,
        };
        setManualCertGenerateForm(form);
        setFile(null);
        setJsonData([]);
        setErrors([]);
        setFileInputKey(Date.now());
        // Clear file input value
        if (fileRef?.current) {
            fileRef.current.value = null;
        }
    }


    const handleGenerateClick = async () => {
        if (errors.length > 0) {
            return error("Please fix the errors before submitting.", "");
        }
        const formData = certGenerateFormRef?.current?.getFormData()
        if (!formData) return error("Please fill in all required fields before submitting.", "");

        const uploadResponse = await manageFileUpload(file);

        const request = {
            EventName: formData.eventName,
            EventDate: formData.eventDate,
            StartTime: formData.startTime,
            EndTime: formData.endTime,
            EncryptedFileName: uploadResponse.fileName,
            UploadedFileName: uploadResponse.uploadedFileName,
            CertificateFor: formData.certificateFor.value,
            CreatedBy : audit.adminUserId,
            CreatedAppId : audit.appId,
            fileDataList: jsonData.map((data) => {
                return {
                    Email: data["Email Address"],
                    CertificateDisplayName: data["Display Name"],
                    BookingReferenceNo: data["Booking Reference Number"] || null,
                    SendCertificate: data["Send Cert (Yes/No)"] === "Yes" ? true : false,
                }
            }),
        }
        console.log({ request })
        submitGenerateCert(request);
    }
    const rowSchema = Yup.object().shape({
        "S/N": Yup.string().nullable(),
        "Email Address": Yup.string().email('Invalid email').required('Email is required'),
        "Display Name": Yup.string().required('Display name is required'),
        "Send Cert (Yes/No)": Yup.string()
            .oneOf(["Yes", "No"], 'Must be Yes or No')
            .required('Send Cert field is required'),
        "Booking Reference Number": Yup.string().nullable(),
    });

    const manageFileUpload = async (f) => {
        const formData = new FormData();
        formData?.append("file", f);
        formData?.append("storagePath", "ManualEventCertExcelFile");
        return await uploadFile(formData).unwrap();
    }
    const openExcelModel = () => {
        if (isExcelUploaded) {
            if (fileRef?.current) {
                fileRef.current.value = null;
            }
        }

        setIsExcelUploaded(!isExcelUploaded);
    }

    // const onFormFieldChange = (fieldName, formData) => {
    // }

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setFile(file);
        const reader = new FileReader();
        reader.onload = (e) => {
            const arrayBuffer = e.target.result;
            const workbook = XLSX.read(arrayBuffer, {
                type: "array",
                cellDates: true,
                cellText: false
            });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
            setJsonData(jsonData);
            validateData(jsonData);
            openExcelModel();
        };
        reader.readAsArrayBuffer(file);
    };

    const validateData = async (jsonData) => {
        const validationErrors = [];
        for (let i = 0; i < jsonData.length; i++) {
            try {
                await rowSchema.validate(jsonData[i], { abortEarly: false });
            } catch (err) {
                validationErrors.push({ row: i + 1, errors: err.errors });
            }
        }
        setErrors(validationErrors);
    };

    return (
        <div>
            <FormCreator
                key={false}
                ref={certGenerateFormRef}
                config={manualCertGenerateForm}
            // onColumnChange={onFormFieldChange}
            >
            </FormCreator>
            <div className=''>
                <div className='mb-3'>
                    <a href="/ManualCertTemplate.xlsx" download style={{ fontSize: '20px' }}>
                        Download Template
                    </a>
                </div>
                <div className=''>
                    {/* File Upload Field */}
                    <div className="col-md-6">
                        <label htmlFor="file-input" className="form-label fw-semibold">
                            Upload File
                        </label>
                        {/* <h2>{JSON.stringify(file?.name)}</h2> */}
                        <div className="input-group">
                            <input
                                type="text"
                                className=""
                                value={file?.name || null}
                                placeholder="No file selected"
                                onClick={() => fileRef.current.click()}
                                readOnly
                            />
                            <Buttons
                                buttonText="Browse File"
                                buttonTypeClassName="btn outline-theme-btn"
                                onClick={() => fileRef.current.click()}
                            />
                        </div>
                        <input
                            key={fileInputKey}
                            ref={fileRef}
                            id="file-input"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                            className="d-none"
                        />
                    </div>
                </div>
            </div>

            {/* <pre>{JSON.stringify(errors, null, 2)}</pre>
            <pre>{JSON.stringify(jsonData, null, 2)}</pre> */}

            {
                isExcelUploaded && <CenterModel
                    modelTitle={'Excel Data'}
                    show={"test"}
                    handleClose={openExcelModel}
                    onUpload={openExcelModel}
                >
                    <CertExcelFileDataTable
                        fileData={jsonData}
                        errors={errors}
                    />

                    <Buttons
                        buttonText="Generate"
                        buttonTypeClassName={`theme-btn btn `}
                        onClick={handleGenerateClick}
                        isLoading={generateCertLoading || isLoading}
                        isDisable={errors?.length > 0 || !jsonData.length}
                    />
                </CenterModel>
            }
        </div >
    )
}

export default GenerateManualEventAttendenceCertificateForm
